import { gql } from "@apollo/client";

export const DayOfWeekEnumTypeDef = gql`
  enum DayOfWeek {
    Friday
    Monday
    Saturday
    Sunday
    Thursday
    Tuesday
    Wednesday
  }
`;
export const DeviceTypesEnumTypeDef = gql`
  enum DeviceTypes {
    Cars
    Console
    Desktop
    Mobile
    Tablet
    Tv
    Unknown
  }
`;
export const FlowActionTypeEnumTypeDef = gql`
  enum FlowActionType {
    Error
    RedirectToCampaign
    RedirectToUrl
  }
`;

export const FlowTypeEnumTypeDef = gql`
  enum FlowType {
    Closing
    Common
    Interceptive
  }
`;

export const OfferGroupTypeEnumTypeDef = gql`
  enum OfferGroupType {
    Percentage
    Sequance
  }
`;

export const FlowErrorTypeEnumTypeDef = gql`
  enum FlowErrorType {
    Error404
    Error503
  }
`;

export const ActivenessStatusInputTypeDef = gql`
  input ActivenessStatus {
    Active: String
    Inactive: String
  }
`;

export const DateRangeInputTypeDef = gql`
  input DateRangeInput {
    from: DateTime
    to: DateTime
  }
`;

export const ClickLimitInputTypeDef = gql`
  input ClickLimitInput {
    amountPer24Hours: Long
    amountPerHour: Long
    amountTotal: Long
  }
`;
export const InversibleFilterOfStringInputTypeDef = gql`
  input InversibleFilterOfString__Input {
    filter: [String]
    useInverse: Boolean!
  }
`;
export const FlowOfferSettingUpsertRequestInputTypeDef = gql`
  input FlowOfferSettingUpsertRequestInput {
    flowId: Long
    id: Long
    offerId: Long!
    percentage: Float
    sequance: Int
  }
`;

export const InversibleFilterOfDeviceTypesInputTypeDef = gql`
  input InversibleFilterOfDeviceTypes__Input {
    filter: [DeviceTypes!]
    useInverse: Boolean!
  }
`;

export const ScheduleInputTypeDef = gql`
  input ScheduleInput {
    day: DayOfWeek
    from: TimeSpan
    to: TimeSpan
  }
`;
export const FiltersInputInputTypeDef = gql`
  input FiltersInput {
    browsers: InversibleFilterOfString__Input
    browserVersions: InversibleFilterOfString__Input
    clickLimit: ClickLimitInput
    countries: InversibleFilterOfString__Input
    dateRange: DateRangeInput
    deviceBrands: InversibleFilterOfString__Input
    deviceModels: InversibleFilterOfString__Input
    deviceTypes: InversibleFilterOfDeviceTypes__Input
    iPs: String
    isBot: Boolean
    languages: InversibleFilterOfString__Input
    operatingSystems: InversibleFilterOfString__Input
    origins: InversibleFilterOfString__Input
    osVersions: InversibleFilterOfString__Input
    referrers: InversibleFilterOfString__Input
    schedule: [ScheduleInput]
    userAgent: String
    xRequestedWith: InversibleFilterOfString__Input
  }
`;

export const FlowUpsertRequestInputTypeDef = gql`
  input FlowUpsertRequestInput {
    campaignId: Long
    campaignIdToRedirect: Long
    filters: FiltersInput
    flowActionType: FlowActionType
    flowErrorType: FlowErrorType
    flowOfferSettings: [FlowOfferSettingUpsertRequestInput!]
    flowType: FlowType!
    id: Long
    name: String!
    offerGroupType: OfferGroupType
    position: Int!
    state: ActivenessStatus!
    urlToRedirect: String
  }
`;

export const TimeCapacityTypesInputTypeDef = gql`
  enum TimeCapacityType {
    All
    Daily
  }
`;
